import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./Dashboard";
import Details from "./Details";
import React from 'react';

function App() {
  return (
    <BrowserRouter>
    
      <div className="App">
          <header className="App-header">
            <div className="z-10 order-2 md:order-1 w-full px-2 h-full md:w-3/4 flex flex-wrap items-center -mt-6 md:mt-0">
            <a href="tg://resolve?domain=kiss92newsongs" className="w-full">
              <Routes>
                <Route path="/" element={
                
                      <div className="min-w-full p-4 md:pr-4 md:pl-4 md:py-4 mt-12 mb-0 md:mx-5 h-full bg-pink-50 rounded-2xl shadow-xl">
                      <h3 className="text-sm text-pink-600"><strong>New!</strong> Subscribe here to get notified when new songs are played on Kiss92.</h3>
                    </div>
                } />
              </Routes>
            </a>
              <div className="min-w-full p-8 md:pr-14 md:pl-14 md:py-12 mx-0 mt-4 mb-8 md:mx-5 h-full bg-pink-50 rounded-2xl shadow-xl">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/s/:songId" element={<Details />} />
                </Routes>
              </div>
            </div>
          </header>
      </div>
    </BrowserRouter>
  );
}

export default App;
